// src/pages/Horoscope.jsx
import React from 'react';
import starbluenomoon from '../assets/starbluenomoon.png';
import './horoscope.css';
import floatinggirl from '../assets/floatinggirl.png';
import floatingcat from '../assets/floatingcat.png';
import girlymoon from '../assets/girlymoon.png';


export default function Horoscope() {
  return (
    <div className="horoscope-page" style={{ backgroundImage: `url(${starbluenomoon})` }}>
      <div className="notes-text">i've been plotting on u</div>

      <div className="various-images">
        <img src={floatinggirl} alt="Girl" className="floatinggirl-image" />
        <img src={floatingcat} alt="Cat" className="floatingcat-image" />
        <img src={girlymoon} alt="Moon" className="girlymoon-image" />
        <div className="random-text"><p>nothing to see here go away</p></div>
      </div>
    </div>
  );
}
